import { render, staticRenderFns } from "./RenderQRCode.vue?vue&type=template&id=56169b44&scoped=true&"
import script from "./RenderQRCode.vue?vue&type=script&lang=js&"
export * from "./RenderQRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56169b44",
  null
  
)

export default component.exports